import classNames, { Argument } from 'classnames';
import { twMerge as tailwindMerge } from 'tailwind-merge';

export const twMerge = (...args: Argument[]) => tailwindMerge(classNames(...args));

export default twMerge;
